import { makeStyles } from "@material-ui/core/styles";

const Style = makeStyles((theme) => ({
  root: {
    height: "90vh",
  },
  content: {
    padding: theme.spacing(0, 3),
    textAlign: "center",

    "& h5": {
      fontSize: 18,
    },
    "& img": {
      height: 320,
    },
  },
  buttonFooter: {
    minWidth: 'fit-content',
    padding: 16,
    marginTop: '20px !important',
    fontFamily: "Geomanist Medium !important",
  },
}));

export default Style;
